export default __webpack_public_path__ + "static/media/crac1.a8dd4702.svg";